<template>
  <div class="header-wrapper">
    <div class="header">
      <div class="container">
        <div class="header__middle">
          <a href="/">
            <img
              src="@/assets/images/monogram.svg"
              class="header__logo--small"
            />
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="holding-page" :class="{ 'holding-page--logged-in': isLoggedIn }">
    <section class="countdown" :class="{ 'countdown--logged-in': isLoggedIn }">
      <div class="centered">
        <div class="container">
          <h2>FLASH SALE</h2>
          <h4>UP TO 70% OFF</h4>
        </div>
      </div>
      <div class="bottom">
        <div class="clock-container">
          <HoldingCountdown class="countdown-clock" :end="endDate" />
        </div>
        <div class="account-buttons">
          <Button
            v-if="isLoggedIn"
            tag="a"
            :href="multipassAccount.url"
            class="account-button"
          >
            Go to account
          </Button>
          <template v-else>
            <Button full-width @click="setSlideLogin(true)"> Sign in </Button>
            <Button full-width @click="setSlideSignUp(true)">
              Create Account
            </Button>
          </template>
        </div>
      </div>
    </section>
  </div>
  <SlideLogin />
  <SlideSignUp />
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import Button from "@/components/Button.vue";

import HoldingCountdown from "@/components/holding/HoldingCountdown.vue";
import SlideLogin from "@/components/SlideLogin.vue";
import SlideSignUp from "@/components/SlideSignUp.vue";

export default {
  name: "HoldingPage",
  components: {
    Button,
    HoldingCountdown,
    SlideLogin,
    SlideSignUp,
  },
  inject: ["mq"],
  props: {
    endDate: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    ...mapState("auth", ["multipassAccount"]),
  },
  mounted() {
    document.getElementById("app").classList.add("holding");
  },
  methods: {
    ...mapActions("app", ["setSlideLogin", "setSlideSignUp"]),
  },
};
</script>

<style lang="scss" scoped>
.holding-page--logged-in {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

section.countdown {
  height: 100vh;
  position: relative;
  background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/Frame_8_1_35792091-2038-4c95-8bb4-8995dcddf3bd.jpg?v=1708001708");
  background-position: top;
  background-size: cover;
  position: relative;

  @include respond-above(md) {
    height: 100vh;
    background-image: url("https://cdn.shopify.com/s/files/1/0942/9062/files/Frame_1_1_1_cf47db9a-8a69-485d-b48f-6e835fb12a15.jpg?v=1707922216");
  }

  ::v-deep(.video__element) {
    object-fit: cover;
  }

  .bottom {
    position: absolute;
    bottom: 100px;
    left: 0;
    right: 0;
    text-align: center;
  }

  .account-buttons {
    display: flex;
    column-gap: 15px;
    justify-content: center;
    margin: 0 40px;

    @include respond-above(md) {
      max-width: 335px;
      margin: 0 auto;
    }
  }

  .container {
    position: absolute;
    margin: 0 auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 2;
  }

  ::v-deep(.countdown-clock) {
    margin-bottom: 35px;
  }

  h2 {
    font-size: 40px;
    font-weight: 400;
    color: $color-white;
    font-family: $heading-font-family;
    text-transform: uppercase;
    margin-bottom: 10px;

    @include respond-above(md) {
      font-size: 64px;
    }
  }
  h4 {
    font-size: 16px;
    font-weight: 400;
    color: $color-white;
    font-family: $heading-font-family;
    text-transform: uppercase;
    margin-bottom: 10px;

    @include respond-above(md) {
      font-size: 24px;
    }
  }
}

.divider {
  position: relative;
  text-align: center;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 600;
  margin-bottom: 20px;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-bottom: solid 1px #d4d4d4;
    width: 40%;
    left: 0;
  }

  &::after {
    left: auto;
    right: 0;
  }
}

section.account {
  text-align: center;
  padding: 45px 0;

  .container {
    max-width: 830px;
  }

  .login-button__wrapper {
    display: flex;
    column-gap: 15px;
    max-width: 100%;
    margin: 0 40px;
    @include respond-above(md) {
      max-width: 335px;
      margin: 0 auto;
    }
  }

  .intro {
    @include respond-above(md) {
      padding: 50px 0;
    }

    h3 {
      margin-bottom: 13px;
      @include t__editorial-body-30;
      text-wrap: balance;

      @include respond-above(md) {
        @include t__editorial-headline-30;
        margin-bottom: 80px;
      }
    }

    p {
      text-wrap: pretty;
      margin-bottom: 30px;
      @include t__editorial-body-10;

      @include respond-above(md) {
        display: block;
      }
    }
  }

  .sso {
    ::v-deep(.sso-buttons) {
      border-bottom: none;
      padding: 0;
      margin-bottom: 0;
      margin-left: 0;
      margin-right: 0;
    }
  }

  ::v-deep(.form) {
    @include respond-above(md) {
      margin: 0 auto;
      max-width: 335px;
    }
  }

  ::v-deep(.sso-buttons .button--medium) {
    @include respond-above(md) {
      max-width: 335px;
      margin: 0 auto;
    }
  }
}

.header {
  &__middle {
    padding: 15px 0;
  }

  &__logo--small {
    display: block;
    height: 22px;
    margin: 0 auto;

    @include respond-above(md) {
      height: 28px;
    }
  }
}

.header {
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0) 100%
  );

  * {
    transition: 0.2s;
  }

  *,
  ::v-deep(button) {
    color: $color-white !important;
  }

  .header__logo {
    filter: invert(1);
    &--small {
      filter: invert(1);
    }
  }
}

.clock-container {
  display: flex;
  justify-content: center;
}
</style>

<style lang="scss">
.holding.fixed-header {
  padding-top: 0;
}
</style>
